<template>
    <div>
        <p>
            Mode
            <b-select v-model="mode" :options="[
                { text: 'Grouper (fusionner en une ligne imbriquée)', value: 'grouper' },
                { text: 'Concaténer (fusionner un texte avec un séparateur)', value: 'separateur' }
            ]" />
        </p>

        <template v-if="mode === 'separateur'">
            <div class="mt-2">
                <strong>Colonne d'identification</strong>
                <small class="text-muted d-block mb-1">Les lignes ayant la même valeur pour cette colonne seront fusionnées ensemble</small>
                <b-input :list="'colidsep' + id" v-model="column_id_single" size="sm" />
                <datalist :id="'colidsep' + id">
                    <option v-for="(c, ci) in columns_data" :key="'cics' + ci">{{ c }}</option>
                </datalist>
            </div>

            <p class="mt-2">
                Séparateur
                <b-input v-model="separator" placeholder=" | " />
            </p>
            <p>
                <b-checkbox v-model="keep_files">Garder les fichiers séparés</b-checkbox>
            </p>
        </template>

        <template v-else>
            <div class="mt-2">
                <strong>Colonne(s) d'identification</strong>
                <small class="text-muted d-block mb-1">Les lignes ayant les mêmes valeurs pour toutes ces colonnes seront fusionnées ensemble</small>
                <b-table-simple small bordered class="mt-1">
                    <b-thead>
                        <b-tr>
                            <b-th>Colonne</b-th>
                            <b-th></b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="(col, idx) in columns_id" :key="'ci' + idx">
                            <b-td>
                                <b-input :list="'colid' + id" v-model="columns_id[idx]" size="sm" />
                                <datalist :id="'colid' + id">
                                    <option v-for="(c, ci) in columns_data" :key="'cic' + ci">{{ c }}</option>
                                </datalist>
                            </b-td>
                            <b-td>
                                <b-button size="sm" variant="danger" @click="columns_id.splice(idx, 1)">✕</b-button>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
                <b-button size="sm" @click="columns_id.push('')">+ Ajouter une colonne</b-button>
            </div>

            <p class="mt-2">
                <b-checkbox v-model="option_delete_other_columns">Supprimer les autres colonnes (ne garder que les colonnes d'identification)</b-checkbox>
            </p>
            <p>
                <b-checkbox v-model="option_keep_first_line">Ne garder que la première ligne correspondante (au lieu de fusionner toutes les données)</b-checkbox>
            </p>
        </template>
    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";

    export default {
        name: "fusionner_lignes",
        props: {
            data: { default: () => [] },
            files: { default: () => [] },
            client: { default: null },
            size: { default: 1000 },
            step_position: { default: 0 }
        },
        watch: {
            data: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.data.length > 0) {
                        this.columns_data = Object.keys(this.data[0]);
                    }
                }
            }
        },
        data() {
            return {
                id: uniqueId(""),
                columns_data: [],

                mode: "grouper",
                columns_id: [""],

                // Concaténer (ancien mode "séparateur") : une seule colonne d'identification
                column_id_single: "",
                separator: " | ",
                keep_files: false,

                // Grouper
                option_delete_other_columns: false,
                option_keep_first_line: false
            };
        },
        methods: {
            save() {
                if (this.mode === "separateur") {
                    return {
                        column_id: this.column_id_single ? this.column_id_single.trim() : "",
                        separator: this.separator || " | ",
                        keep_files: this.keep_files
                    };
                }

                var ids = this.columns_id.filter(c => c && c.trim() !== "");

                return {
                    column_id: ids,
                    option_delete_other_columns: this.option_delete_other_columns,
                    option_keep_first_line: this.option_keep_first_line
                };
            },
            async load(data) {
                if (!data) return;

                this.separator = data.separator || " | ";
                this.keep_files = !!data.keep_files;
                this.option_delete_other_columns = !!data.option_delete_other_columns;
                this.option_keep_first_line = !!data.option_keep_first_line;
                this.mode = data.separator ? "separateur" : "grouper";

                if (Array.isArray(data.column_id)) {
                    this.columns_id = data.column_id.length > 0 ? data.column_id.slice() : [""];
                    this.column_id_single = data.column_id.length > 0 ? data.column_id[0] : "";
                } else if (data.column_id) {
                    this.columns_id = [data.column_id];
                    this.column_id_single = data.column_id;
                } else {
                    this.columns_id = [""];
                    this.column_id_single = "";
                }
            }
        }
    };
</script>

<style scoped>
</style>
